// Phase 9B — AgentsPage.
//
// Route-level wrapper for Agent Workload dashboard.

import { AgentWorkloadPage } from "../../modes/agents/AgentWorkloadPage.tsx";

export function AgentsPage(): JSX.Element {
  return <AgentWorkloadPage />;
}
